<button
  type="button"
  class="content-item"
  cdkMonitorElementFocus
  [class.content-item--selected]="selected()"
  [class.content-item--muted]="muted()"
  [class.content-item--danger]="tone() === 'danger'"
  [class.content-item--selector]="variant() === 'selector'"
  [class.content-item--truncate-description]="truncateDescription()"
  [disabled]="disabled()"
  [attr.aria-label]="ariaLabel() || null"
  [attr.role]="control() === 'switch' ? 'switch' : null"
  [attr.aria-checked]="control() === 'switch' ? checked() : null"
  [attr.aria-expanded]="control() === 'expand' ? expanded() : null"
  [attr.aria-current]="variant() !== 'selector' && control() !== 'switch' && selected() ? 'true' : null"
  [attr.aria-pressed]="variant() === 'selector' && control() === 'check' ? selected() : null"
  (click)="onPress()"
>
  <aw-content-row
    [variant]="variant() === 'selector' ? 'selector' : 'default'"
    [avatarShape]="avatarShape()"
    [initials]="initials()"
    [tone]="tone()"
    [fileName]="fileName()"
    [icon]="icon()"
    [iconColor]="iconColor()"
    [iconBadge]="iconBadge()"
    [image]="image()"
    [emoji]="emoji()"
  >
    <ng-content select="[leading]" ngProjectAs="[leading]" />
    @if (variant() === 'add-checklist') {
      <span leading class="content-item__empty-check" aria-hidden="true"></span>
    }
    <span class="content-item__copy" [class.content-item__copy--described]="!!description()">
      @if (fieldName()) {
        <span class="content-item__field-name">{{ fieldName() }}</span>
      }
      <span class="content-item__value">
        <ng-content select="[value-leading]" />
        <span class="content-item__label">{{ label() }}</span>
        <ng-content select="[value-trailing]" />
      </span>
      @if (description()) {
        <span class="content-item__description">{{ description() }}</span>
      }
    </span>
    <ng-content />
    <ng-content select="[trailing]" ngProjectAs="[trailing]" />
    @if (control() !== 'none' && (control() !== 'check' || selected())) {
      <span trailing class="content-item__control" aria-hidden="true">
        @switch (control()) {
          @case ('switch') {
            <aw-switch-button-old [presentation]="true" [value]="checked()" [disabled]="disabled()" />
          }
          @case ('picker') {
            <i class="aw-2-icn" [awIcon]="'chevrons-up-down'"></i>
          }
          @case ('chevron') {
            <i class="aw-2-icn" [awIcon]="'chevron_right'"></i>
          }
          @case ('external') {
            <i class="aw-2-icn" awIcon="external-link"></i>
          }
          @case ('expand') {
            <i class="aw-2-icn" awIcon="expand_more" [style.transform]="expanded() ? 'rotate(180deg)' : null"></i>
          }
          @case ('check') {
            @if (selected()) {
              <i class="aw-2-icn" awIcon="check"></i>
            }
          }
        }
      </span>
    }
    @if (badge()) {
      <span trailing class="content-item__badge">{{ badge() }}</span>
    }
  </aw-content-row>
</button>
